
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import PlaceIcon from '@mui/icons-material/Place';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useNavigate, useLocation } from "react-router-dom";


const BottomNavBar = () => {
const navigate = useNavigate();
const location = useLocation();

const currentPath = location.pathname;

const getTabValue = () => {
  if (currentPath.startsWith("/checkpointList")) return 0;
  if (currentPath.startsWith("/profile")) return 2;
  return 1; // default to Map
};

  const handleChange = (event, newValue) => {
    if (newValue === 0) navigate("/checkpointList");
    if (newValue === 1) navigate("/mapOverview");
    if (newValue === 2) navigate("/profile");
  };
  return (
    <BottomNavigation
      showLabels
      value={getTabValue()}
       onChange={handleChange}
      sx={{
        position: 'fixed',
        bottom: 0,
        width: '100%',
        zIndex: 1000,
        borderTop: '1px solid #ddd',
      }}
    >
      <BottomNavigationAction  label="Checkpoints" icon={<PlaceIcon />} />
      <BottomNavigationAction label="Map" icon={<MapIcon />}
       />
      
      <BottomNavigationAction label="Profile" icon={<AccountCircleIcon />} />
    </BottomNavigation>
  );
};

export {BottomNavBar};
